<template>
  <v-app>
    <v-navigation-drawer
        app
        v-model="drawer"
        v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-list>
        <v-list-item-group>
          <v-list-item @click="() => gotoHome()" v-if="showBreadcrumb">
            <v-list-item-icon>
              <v-icon>home</v-icon>
            </v-list-item-icon>
            <v-list-item-title
            >{{ $vuetify.lang.t("$vuetify.kba.breadcrumb.start") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="loggedin" @click="logout()">
            <v-list-item-icon>
              <v-icon>logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title
            >{{ $vuetify.lang.t("$vuetify.kba.header.logout.label") }}
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
        <v-divider class="mt-3"/>

        <v-list-item-group>
          <v-list-item
              v-for="(item, i) in itemsInDrawerAlwaysPresent"
              :key="i"
              :href="item.href"
          >
            <v-list-item-title>
              {{ item.label }}
            </v-list-item-title>
          </v-list-item>

        </v-list-item-group>

      </v-list>
    </v-navigation-drawer>
    <v-app-bar
        app
        :max-width="innerWidth"
        color="primary"
        dark
        v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-app-bar-nav-icon @click="drawer = true"/>
      <v-app-bar-title>{{ t('title') }}</v-app-bar-title>
    </v-app-bar>

    <v-main>

      <CookiePolicy/>
      <div style="height: 320px" v-if="$vuetify.breakpoint.mdAndUp">
        <v-parallax
            :src="require('../assets/header.jpg')"
            height="360"
        >
          <v-row no-gutters justify="center">
            <v-col cols="8">
              <v-row id="top-stripe"/>
              <v-row class="white">
                <v-col cols="3" class="text-left" id="upper-kba-logo">
                  <KbaLogo/>
                </v-col>
                <v-spacer/>
                <UpperRightNavigation
                    :defaultNaviItems="itemsInDrawerAlwaysPresent"
                    id="upper-right-navigation"
                />
              </v-row>
              <v-row class="primary py-0">
                <v-col class="py-0" cols="md" lg="5">
                  <v-breadcrumbs dark v-if="showBreadcrumb" justify-end>
                    <v-breadcrumbs-item
                        active-class="white&#45;&#45;text"
                        to="/"
                    >
                      Start / World Manufacturer Identifier
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-divider
                        v-if="currentRouteName !== '-' && this.$route.meta.titel !== 'Homeseite'"
                    >
                      /
                    </v-breadcrumbs-divider>
                    <v-breadcrumbs-item
                        v-if="currentRouteName !== '-' && this.$route.meta.titel !== 'Homeseite'"
                    >
                      {{ currentRouteName }}
                    </v-breadcrumbs-item>
                  </v-breadcrumbs>
                </v-col>
                <v-col class="py-0" cols="md" lg="7">
                  <v-breadcrumbs dark v-if="showBreadcrumb" justify-end>
                    <v-breadcrumbs-item>
                      <v-btn color="primary"
                            title="Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet ein neues Fenster)"
                            href="https://www.kba.de/DE/Themen/Typgenehmigung/CoC_Daten_Fahrzeugtypdaten/Veroeffentlichungen/SV3.html?nn=3505666"
                            target="_blank">
                        Verzeichnis der Hersteller des <br>
                        aktuellen Kalenderjahres
                        <v-icon right>
                          chevron_right
                        </v-icon>
                      </v-btn>
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-item>
                      <v-btn color="primary"
                             target="_blank"
                             @click="info()"
                      >
                        Kontakt zum Fachbereich
                      </v-btn>
                    </v-breadcrumbs-item>
                  </v-breadcrumbs>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

        </v-parallax>
      </div>

      <DialogKontakt
          v-model="kontaktdialog.show"
      />


      <v-row no-gutters justify="center" class="pb-10">
        <v-col cols="sm" md="8" sm="12">
          <component
              :is="$vuetify.breakpoint.mdAndDown ? 'div' : 'v-card'"
              class="mb-5"
          >
            <v-card class="elevation-5">
              <component :is="$vuetify.breakpoint.mdAndDown ? 'div' : 'v-card'">
                <slot/>
              </component>
              <v-divider/>
            </v-card>
          </component>
        </v-col>
      </v-row>

    </v-main>

    <v-footer app absolute padless>
      <v-card flat tile width="100%">
        <v-row
            justify="center"
            align="center"
            class="white"
            v-if="$vuetify.breakpoint.mdAndUp"
        >
          <v-col cols="md" sm="12" md="6">
            <v-row>
              <v-col cols="6" align="right">
                <KbaLogo/>
              </v-col>
              <v-col cols="6">
                <p class="font-weight-bold">
                  {{
                    $vuetify.lang.t("$vuetify.kba.footer.kba.titleLong")
                  }}
                </p>
                <p>
                  {{ this.itemsInMiddlefooter.description }}

                  <a :href="this.itemsInMiddlefooter.bmvhref"
                     target="_blank"
                     :title="this.itemsInMiddlefooter.bmvtitle"
                  >
                    {{ this.itemsInMiddlefooter.bmvlabel }}
                  </a>
                </p>
                <p class="mt-4"> Kraftfahrt-Bundesamt, Flensburg </p>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="md" sm="12" lg="6">
            <v-row>
              <v-col class="text-center">
                <p class="text-h1" style="color: #014b76"> 115 </p>
              </v-col>
              <v-col>
                <p class="font-weight-bold">
                  {{ this.itemsInMiddlefooter.centralAuthorityNumber }}
                </p>
                <p>
                  {{ this.itemsInMiddlefooter.infoNumber }}
                </p>
                <p>
                  {{ this.itemsInMiddlefooter.hours }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center" align="center" class="grey lighten-4 py-5">
          <v-col cols="5" class="text-center">
            <span>    &copy; Kraftfahrt-Bundesamt, Flensburg    </span>
          </v-col>
          <v-col cols="sm" sm="12" md="auto">
            <v-row>
              <v-col
                  cols="sm" sm="12" md="auto" class="text-center" :key="item.label"
                  v-for="item in itemsInLowerfooter"
              >
                <v-btn text :title="item.title" type="a" :href="item.href" target="_blank">
                  {{ item.label }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import SelectLanguage from '../components/SelectLanguage'
import KbaLogo from '../components/KbaLogo'
import UpperRightNavigation from '../components/UpperRightNavigation'
import CookiePolicy from '../views/CookiePolicy'
import DialogKontakt from "@/components/formular/DialogKontakt.vue"

export default {
  name: 'LayoutDefault',
  components: {DialogKontakt, SelectLanguage, KbaLogo, UpperRightNavigation, CookiePolicy},
  props: {
    store: {
      type: String,
      default: 'antragsformular'
    }
  },
  data: () => {
    return {
      drawer: false,
      scroll: {
        y: 0
      },
      kontaktdialog: {
        show: false
      }
    }
  },
  computed: {
    showBreadcrumb() {
      return !this.$route.meta || !this.$route.meta.suppressBreadcrumb
    },
    currentRouteName() {
      if (
          this.$route.meta &&
          this.$route.meta.titel
      ) {
        return this.$route.meta.titel
      }
      return ''
    },
    itemsInDrawerAlwaysPresent() {
      const keysAlwaysPresent = ['contact', 'press', 'glossary', 'rss']
      return keysAlwaysPresent.map((key) => {
        return {
          href: this.$vuetify.lang.t(`$vuetify.kba.header.${key}.href`),
          label: this.$vuetify.lang.t(`$vuetify.kba.header.${key}.label`),
          title: this.$vuetify.lang.t(`$vuetify.kba.header.${key}.title`)
        }
      })
    },
    itemsInMiddlefooter() {
      return {
        description: this.$vuetify.lang.t(`$vuetify.kba.footer.middleFooter.description`),
        bmvlabel: this.$vuetify.lang.t(`$vuetify.kba.footer.middleFooter.bmv.label`),
        bmvhref: this.$vuetify.lang.t(`$vuetify.kba.footer.middleFooter.bmv.href`),
        bmvtitle: this.$vuetify.lang.t(`$vuetify.kba.footer.middleFooter.bmv.title`),
        centralAuthorityNumber: this.$vuetify.lang.t(`$vuetify.kba.footer.middleFooter.centralAuthorityNumber`),
        infoNumber: this.$vuetify.lang.t(`$vuetify.kba.footer.middleFooter.infoNumber`),
        hours: this.$vuetify.lang.t(`$vuetify.kba.footer.middleFooter.hours`)
      }
    },
    itemsInLowerfooter() {
      const keysAlwaysPresent = ['accessibility', 'imprint', 'privacy', 'explanation', 'content']
      return keysAlwaysPresent.map((key) => {
        return {
          href: this.$vuetify.lang.t(`$vuetify.kba.footer.lowerFooter.${key}.href`),
          label: this.$vuetify.lang.t(`$vuetify.kba.footer.lowerFooter.${key}.label`),
          title: this.$vuetify.lang.t(`$vuetify.kba.footer.lowerFooter.${key}.title`)
        }
      })
    },
    publicPath() {
      return process.env.BASE_URL
    },

    loggedin: {
      get() {
        return this.$store.getters['loggedin/loggedin']
      },
      set(value) {
        this.$store.commit('loggedin/loggedin', value)
      }
    }

  },
  methods: {
    info() {
      this.kontaktdialog.show = true
    },
    t(value) {
      return this.$vuetify.lang.t('$vuetify.' + value)
    },
    gotoHome() {
      this.$router.push("/home")
    },
    logout() {
      this.$http.post('logout').then(() => {
        this.$router.go()
        this.loggedin = false
      }).catch(error => {
        console.log(error)
      })
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      this.scroll.y = window.scrollY
    })
  },

  mounted() {
  }
}
</script>

<style lang="scss">
@import "../assets/wmi-styles.scss";

.v-breadcrumbs__item {
  color: white !important;
}

.tab {
  margin-left: 1em;
}

#upper-kba-logo {
  padding-left: $ora-spacing-global-left-rim !important;
  margin: 20px 0;
}

#spinner-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;

  > div {
    left: 50%;
    top: 45%;
    margin-left: -20px;
  }
}

.kontakt {
  > div {
    left: 50%;
    top: 45%;
    margin-left: -20px;
  }
}

.card-title {
  p {
    font-style: italic;
    -webkit-hyphens: manual;
    -moz-hyphens: manual;
    hyphens: manual;
    font-size: 200%;
    width: 100%;
    display: inline;
    margin-left: 0.2em;
  }

  &::before {
    content: "/";
    font-style: normal;
    font-size: 400%;
    color: $color-main;
    padding-left: $ora-spacing-global-left-rim !important;
  }
}

#top-stripe {
  background: $color-main;
  height: 20px;
}

$KBA_LOGO_HEIGHT: 82px;
#upper-right-navigation {
  margin-right: $ora-spacing-global-left-rim;
  margin-top: $KBA_LOGO_HEIGHT + 14px;
}
</style>
